import React from "react";
import { Box } from "grommet";
import { normalizeColor } from "grommet/utils";
import { useDarkMode } from "../components/DarkModeSwitch";
import Theme from "../utils/Theme";
import CodeMirror, { basicSetup } from "@uiw/react-codemirror";
import { githubLight, githubDark } from "@uiw/codemirror-theme-github";
import { autocompletion, CompletionContext } from "@codemirror/autocomplete";

const SeasonSchedulePlanner = ({ value, onChange, teams }) => {
    // const boxRef = React.useRef<HTMLDivElement>(null);

    // const editorStateRef = React.useRef<EditorState>();

    // React.useEffect(() => {
    //     if (!boxRef.current) return;

    //     editorStateRef.current = EditorState.create({
    //         doc: "Hello World",
    //         extensions: [keymap.of(defaultKeymap)],
    //     });

    //     let myView = new EditorView({
    //         extensions: [keymap.of(defaultKeymap)],
    //         parent: boxRef.current,
    //         state: editorStateRef.current,
    //     });
    // }, [boxRef]);

    // React.useEffect(() => {
    //     if (!editorStateRef.current) return;
    // }, [editorStateRef.current?.doc]);

    const [isDarkMode, toggleDarkMode] = useDarkMode();

    const myCompletions = React.useMemo(
        () =>
            function (context: CompletionContext) {
                let word = context.matchBefore(/\w*/);
                if (!word || (word.from == word.to && !context.explicit)) return null;
                return {
                    from: word.from,
                    options: teams.map((t) => ({label:t.name})),
                };
            },
        [teams]
    );

    return (
        <>
            <Box style={{ border: "none", backgroundColor: normalizeColor("background", Theme, isDarkMode) }}>
                <CodeMirror value={value} onChange={onChange} extensions={[autocompletion({ override: [myCompletions] })]} theme={isDarkMode ? githubDark : githubLight} />
            </Box>
        </>
    );
};

export default SeasonSchedulePlanner;
